import {apiBase} from 'api/base.js';

class CowEventImportAPI {
  create(params) {
    return apiBase.post('/admin/cow_event_import', params);
  }

  update(params) {
    return apiBase.put('/admin/cow_event_import', params);
  }

  delete(params) {
    return apiBase.delete('/admin/cow_event_import', params);
  }
}

export const cowEventImportAPI = new CowEventImportAPI();
